// extracted by mini-css-extract-plugin
export default {"buttonMoveTag":"ButtonMoveTag-module__buttonMoveTag"};